import { canSetCampaignCookie, getCampaignCookie } from './cookieManager';
import { normalizeUtmValue } from './utils';

export interface UtmFieldsCamelCase {
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
}

/**
 * Build UTM fields for backend payloads using camelCase field naming.
 *
 * - Always returns all 3 fields; empty strings if cookie absent or consent denied.
 * - Truncates to 255 chars per CPI requirements.
 *
 * @see BEC-20520 Campaign Tracker implementation
 */
export const getUtmFieldsCamelCase = (
  countryCode: string,
): UtmFieldsCamelCase => {
  const empty: UtmFieldsCamelCase = {
    utmSource: '',
    utmMedium: '',
    utmCampaign: '',
  };

  // If consent gating denies usage, still return empty fields (always present rule)
  if (!canSetCampaignCookie(countryCode)) {
    return empty;
  }

  const cookie = getCampaignCookie();
  if (!cookie) {
    return empty;
  }

  return {
    utmSource: normalizeUtmValue(cookie.utm_source ?? ''),
    utmMedium: normalizeUtmValue(cookie.utm_medium ?? ''),
    utmCampaign: normalizeUtmValue(cookie.utm_campaign ?? ''),
  };
};
